import { render, staticRenderFns } from "./Foro.vue?vue&type=template&id=4d280b52&scoped=true&"
import script from "./Foro.vue?vue&type=script&lang=js&"
export * from "./Foro.vue?vue&type=script&lang=js&"
import style0 from "./Foro.vue?vue&type=style&index=0&id=4d280b52&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d280b52",
  null
  
)

export default component.exports